<template>
<div class="coursec-info flex">
    <div class="course-left">
        <userDetailInfo @removeLookInfo="removeLookInfo" :giveOrder="giveOrder" @routerLinkHome="routerLinkHome" :userInfo="userInfo"></userDetailInfo>
        <courseChapter :detailId="detailId" @removeLookInfo="removeLookInfo" :lookInfo="lookInfo" :watchChapter="watchChapter" :giveOrder="giveOrder" :orderInfo="orderInfo" :goodDetailId="goodDetailId" @chooseCourseDetails="chooseCourseDetails" :payProgress="payProgress" :goodInfo="goodInfo"></courseChapter>
    </div>
    <div class="course-right">
        <router-view @changeChapter="changeChapter" @removeLookInfo="removeLookInfo" :watchChapter="watchChapter" :lookInfo="lookInfo" :giveOrder="giveOrder" :orderInfo="orderInfo" :detailImage="detailImage" :chooseCourseDetail="chooseCourseDetail" :goodDetailId="goodDetailId" :payProgress="payProgress" :successRateVal="successRateVal" @changeRateValueVisible="changeRateValueVisible" :goodInfo="goodInfo" />
    </div>

    <!--   <el-dialog class="rateValueVisible" :visible.sync="rateValueVisible" style="margin-top: calc(100vh - 360px);" :modal="false">
      <div>
        <div class="rateContent">
          <div class="rateItem">
            <p>请对课程做出评价</p>
            <div class="rateInfo">
              <el-rate :texts="['非常不满意', '不满意', '一般', '满意', '非常满意']" v-model="rateValue" void-color="#f5f5f5"
                :void-icon-class="iconClasses" text-color="#999" show-text>
              </el-rate>
            </div>
          </div>
          <div class="rateItem">
            <p>您对该课程有哪些补充建议？</p>
            <div class="rateInfo">
              <el-input type="textarea"  placeholder="请输入内容" v-model="remarks">
              </el-input>
            </div>
          </div>
        </div>
        <div class="footer">
          <el-button type="primary" @click="saveRateInfo">提 交</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="rateValueVisible2" :visible.sync="feedbackVisible" style="width:228px!important;height: 100px!important;;margin-top: calc(100vh - 360px);" :modal="false">
        <div  class="feedback" style="height: 100px;">
          <img src="https://lf1-cdn-tos.bytescm.com/obj/cc-static/thankyou.gif" alt="知视猫">
          <p>感谢您的反馈</p>
        </div>
      </el-dialog>-->

</div>
</template>

<script>
import {
    getGood
} from "@/api/good.js"
import {
    getOrder,
    orderListData,
    getOrderGive
} from "@/api/order.js"
import {
    findGoodDetailLookFlag
} from "@/api/good.js"

import userDetailInfo from "./components/user-info.vue"
import courseChapter from "./components/course-chapter.vue"
import {
    getLocalStorage
} from "@/utils/auth";
export default {
    components: {
        userDetailInfo,
        courseChapter
    },
    data() {
        return {
            watchChapter: [], //需要先观看的章节
            lookInfo: '', //观看要求
            giveOrder: 0, //是否是赠送单
            beforeDestroyParent: false, //默认未离开
            detailImage: [], //详情图
            successRateVal: 0, //完成评价
            remarks: '', //介意
            iconClasses: ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'],
            rateValueVisible: false, //评分是否展示
            feedbackVisible: false, //评分是否展示
            rateValue: '', //评分
            chooseCourseDetail: '', //课程详情
            goodDetailId: '', //当前点击的课程详情
            payProgress: 0, //当前产品是否购买
            userInfo: '', //用户信息
            goodInfo: '',
            courseId: '', //课程编号
            orderId: '', //订单编号
            orderInfo: '', //订单信息
            detailId: '', //章节Id
        }
    },
    mounted() {
        if (this.$route.query.orderId && !this.$route.query.giveOrder) {
            this.orderId = this.$route.query.orderId
            this.orderDetail()
        } else if (this.$route.query.orderId && this.$route.query.giveOrder == 1) {
            this.getOrderGive()
            this.giveOrder = this.$route.query.giveOrder
        } else {
            this.$router.push('/')
        }
    },
    methods: {
        // 切换章节
        changeChapter(info) {
            this.detailId = info.id;
            this.chooseCourseDetails(info)
        },
        // 移除观看章节
        removeLookInfo() {
            this.lookInfo = "";
            this.watchChapter = [];
        },
        /**
         * 查看课程的观看条件
         * @param  goodId 商品Id
         */
        async findGoodDetailLookFlag() {
            let res = await findGoodDetailLookFlag(this.courseId);
            if (res.data) {
                let data = JSON.parse(res.data);
                if (this.orderInfo.watchSecs < data.totalSecs) {
                    this.lookInfo = data;
                    this.watchChapter = data.goodDetails;
                }
            }
        },

        //获取订单列表
        async getOrderGive() {
            let orderInfo = await getOrderGive(this.$route.query.orderId)
            this.courseId = orderInfo.data.goodId
            this.orderInfo = orderInfo.data
            this.getGood()
        },
        //回到首页信息
        routerLinkHome() {
            this.$router.replace('/user')
        },
        //查询订单信息
        async orderDetail() {
            let getOrderInfo = await getOrder({
                id: this.orderId
            })
            if (getOrderInfo.data) {
                this.courseId = getOrderInfo.data.goodId
                this.orderInfo = getOrderInfo.data
                this.getGood()
                this.findGoodDetailLookFlag()
            }
            /* if (this.$route.query.id) {
               this.courseId = this.$route.query.id
               this.getGood()
             }*/
        },
        //评分内容
        changeRateValueVisible() {
            this.rateValueVisible = true
        },
        //选择章节
        chooseCourseDetails(detailInfo) {
            this.beforeDestroyParent = false
            detailInfo.lastDetailSecs = 0;
            if (detailInfo.study == true) {
                this.getGood()
                this.chooseCourseDetail = detailInfo
            } else {
                this.chooseCourseDetail = detailInfo
            }

        },
        //课程详情
        async getGood() {
            let goodInfo = await getGood({
                id: this.courseId
            })
            if (goodInfo.result == 'true') {
                if (goodInfo.data.contentCover && goodInfo.data.contentCover != '') {
                    if (goodInfo.data.contentCover && goodInfo.data.contentCover.indexOf(',') != -1) {
                        //以前使用，拼接的产品
                        this.detailImage = goodInfo.data.contentCover.split(',');
                    } else {
                        this.detailImage = goodInfo.data.detailImages
                    }
                }
                if (goodInfo.data.mixContent) { //详情数据替换
                    var re2 = new RegExp('＞', 'g')
                    var re1 = new RegExp('＜', 'g')
                    var re4 = new RegExp('＂', 'g')
                    var msg = goodInfo.data.mixContent.replace(re1, '<') // 执行替换成空字符
                    var msg2 = msg.replace(re2, '>') // 执行替换成空字符
                    var msg3 = msg2.replace(re4, '"') // 执行替换成空字符
                    goodInfo.data.mixContent = msg3
                }
            }
            this.goodInfo = goodInfo.data
        }
    }
}
</script>

<style lang="scss" scoped>
.coursec-info {

    .rateValueVisible::v-deep {

        // margin-top: 30px;
        .el-dialog__header {
            padding: 0;
        }

        .el-dialog__footer {
            padding-bottom: 0;

            .dialog-footer {}
        }

        .footer {
            display: flex;
            justify-content: flex-end;

            button {
                padding: 8px 10px;
                min-width: 90px;
                border-color: #2f88ff !important;
                background-color: #2f88ff !important;
            }
        }

        .feedback {
            text-align: center;

            img {
                width: 150px;
            }

            p {
                text-align: center;
                color: #333;
                font-family: PingFangSC-Semibold,
                    sans-serif;
                font-weight: bold;
            }
        }

        .el-dialog {
            margin-top: calc(100vh - 360px) !important;
            // margin-top: 10px !important;
            position: fixed;
            bottom: 50px;
            max-width: 400px;
            // max-height: 320px;
            box-sizing: border-box;
            background: #fff;
            border-radius: 8px;
            padding: 32px 0 24px;
            overflow: visible;
            margin-right: 0;
            top: 0;
            right: 32px;

            .el-icon-close {
                font-size: 18px;
            }

            .el-dialog__body {
                padding-top: 0;
                padding-bottom: 0;
            }

            .rateContent {
                margin-top: -30px;

                .rateItem {
                    &:nth-of-type(2) {
                        height: 140px;
                    }

                    color: #333;
                    font-family: PingFangSC-Semibold,
                    sans-serif;
                    font-weight: bold;

                    &>p::before {
                        display: inline-block;
                        width: 4px;
                        height: 4px;
                        margin: 0;
                        background: #f45858;
                        border-radius: 50%;
                        content: "";
                        margin-right: 4px;
                    }

                    .rateInfo {
                        height: 55px;

                        .el-rate {
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                        }

                        textarea {
                            height: 80px;
                            width: 100%;
                            resize: none;
                        }

                        .el-rate__icon {
                            font-size: 36px;
                            height: 42px;
                        }

                        .el-rate__text {
                            width: 400px;
                            font-size: 12px;
                            font-weight: normal;
                            text-align: center;
                        }
                    }

                }
            }
        }

    }

    .rateValueVisible2::v-deep {
        @extend .rateValueVisible;

        .el-dialog {
            margin-top: calc(100vh - 260px) !important;
            width: 340px;
            height: 240px;
        }

    }

    .course-left {
        position: fixed;
        left: 0;
        width: 420px;
        height: 100vh;
        margin-right: 8px;
        background: #fff;

    }

    .course-right {
        background-color: #f8f8f8;
        padding-left: 428px;
        width: 100%;
        height: 100vh;
        // background: #fff;
    }
}
</style>
